// extracted by mini-css-extract-plugin
export default {"gallery":"c-p_gb","gallery__header":"c-p_gc","gallery__thumbs":"c-p_ge"};